/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransfersControllerListTransfersQueryResponse, TransfersControllerListTransfersQueryParams, TransfersControllerListTransfers401, TransfersControllerListTransfers403 } from "../../models/transfersController/TransfersControllerListTransfers";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { transfersControllerListTransfers } from "../../clients/transfersService/transfersControllerListTransfers";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const transfersControllerListTransfersQueryKey = (params: TransfersControllerListTransfersQueryParams = {}) => [{
  url: '/api/v1/transfers'
}, ...(params ? [params] : [])] as const;
export type TransfersControllerListTransfersQueryKey = ReturnType<typeof transfersControllerListTransfersQueryKey>;
export function transfersControllerListTransfersQueryOptions(params?: TransfersControllerListTransfersQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = transfersControllerListTransfersQueryKey(params);
  return queryOptions<TransfersControllerListTransfersQueryResponse, ResponseErrorConfig<TransfersControllerListTransfers401 | TransfersControllerListTransfers403>, TransfersControllerListTransfersQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return transfersControllerListTransfers(params, config);
    }
  });
}

/**
 * @summary List all transfer runs
 * {@link /api/v1/transfers}
 */
export function useTransfersControllerListTransfers<TData = TransfersControllerListTransfersQueryResponse, TQueryData = TransfersControllerListTransfersQueryResponse, TQueryKey extends QueryKey = TransfersControllerListTransfersQueryKey>(params?: TransfersControllerListTransfersQueryParams, options: {
  query?: Partial<QueryObserverOptions<TransfersControllerListTransfersQueryResponse, ResponseErrorConfig<TransfersControllerListTransfers401 | TransfersControllerListTransfers403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? transfersControllerListTransfersQueryKey(params);
  const query = useQuery({
    ...transfersControllerListTransfersQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TransfersControllerListTransfers401 | TransfersControllerListTransfers403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}